import { ApolloProvider } from "@apollo/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "./components/Layout";
import PageHeader from "./components/PageHeader";
import ScrollToTop from "./components/ScrollToTop";
import AuthContextProvider from "./context/auth/AuthContextProvider";
import client from "./graphql/client";
import About from "./pages/About";
import Introduction from "./pages/Introduction";
import Summary from "./pages/Summary";
import Submission from "./pages/Submission";
import Sentry from "./sentry";
import TrackingProvider from "./middleware/analytics/components/TrackingProvider";
import PSRServicesSelection from "./pages/PSRServicesSelection/index";
import FeatureFlagProvider from "./middleware/featureFlags/FeatureFlagProvider";
import TemporaryNeeds from "./pages/TemporaryNeeds";
import { PATHS } from "./config/routeConfig";
import OptForPSR from "./pages/OptForPSR";
import CustomerPSRSummary from "./pages/CustomerPSRSummary";
import CustomerPSRSubmission from "./pages/CustomerPSRSubmission";
import UnsupportedBrowser from "./components/UnsupportedBrowser";

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <ApolloProvider client={client}>
        <Layout>
          <title>Utility Warehouse help and support</title>
          <AuthContextProvider>
            <FeatureFlagProvider>
              <TrackingProvider>
                <BrowserRouter>
                  <ScrollToTop />
                  <PageHeader />
                  <UnsupportedBrowser />
                  <Routes>
                    <Route path="/" element={<Introduction />} />
                    <Route
                      path={PATHS.Introduction}
                      element={<Introduction />}
                    />
                    <Route path={`${PATHS.About}/*`} element={<About />} />
                    <Route path={PATHS.Summary} element={<Summary />} />
                    <Route path={PATHS.Submission} element={<Submission />} />
                    <Route path={PATHS.OptForPSR} element={<OptForPSR />} />
                    <Route
                      path={PATHS.TemporaryNeeds}
                      element={<TemporaryNeeds />}
                    />
                    <Route
                      path={PATHS.PSRServices}
                      element={<PSRServicesSelection />}
                    />
                    <Route
                      path={PATHS.PSRSummary}
                      element={<CustomerPSRSummary />}
                    />
                    <Route
                      path={PATHS.PSRSubmission}
                      element={<CustomerPSRSubmission />}
                    />
                  </Routes>
                </BrowserRouter>
              </TrackingProvider>
            </FeatureFlagProvider>
          </AuthContextProvider>
        </Layout>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  );
};

export default Sentry.withProfiler(App);
